import React, { FC } from 'react';

import './BackgroundBar.scss';

type Props = {
  onClick?: Function;
  className?: string;
  contentClassName?: string;
  children: React.ReactNode;
};

const BackgroundBar: FC<Props> = ({
  children,
  className,
  contentClassName,
  onClick
}) => {
  return (
    <div
      role={onClick ? 'link' : 'none'}
      className={`${className} background-bar`}
      onClick={onClick ? () => onClick() : undefined}>
      <div className={`${contentClassName} background-bar-content`}>
        {children}
      </div>
    </div>
  );
};

export default BackgroundBar;
